<template>
  <div>
    <div class="m-2">
      <b-card
        class="shadow-none bg-transparent border-secondary"
      >
        <h5 class="font-weight-bolder mb-2">
          Handling Preferences
        </h5>
        <b-row>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <b-form-checkbox
              v-model="handlingCallMe"
              :value="1"
              :unchecked-value="0"
            >
              Call me
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <b-form-checkbox
              v-model="handlingUseDoorBill"
              :value="1"
              :unchecked-value="0"
            >
              Use door bill
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <b-form-checkbox
              v-model="laundryBagNextToTheDoor"
              :value="1"
              :unchecked-value="0"
            >
              Laundry bag next to the door
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <div class="d-flex flex-column justify-content-between align-items-start">
              <b-form-checkbox
                v-model="handlingContactAnotherNumber"
                :value="1"
                :unchecked-value="0"
              >
                Contact another number
              </b-form-checkbox>
              <b-form-input
                v-if="handlingContactAnotherNumber"
                v-model="handlingPhone"
                type="text"
                placeholder="Phone Number"
                class="w-50 mt-1"
                @keypress="numbersOnly"
              />
            </div>
          </b-col>
        </b-row>
        <preferences-default-day-time
          number="1"
          :edit-default-pickup-date-time="editDefaultPickupDateTime"
          :default-pickup-day-text="defaultPickupDayText"
          :default-pickup-time-text="defaultPickupTimeText"
          :default-pickup-day="defaultPickupDay"
          :default-pickup-time="defaultPickupTime"
          :pickup-days="pickupDays"
          :pickup-hours="pickupHours"
          @editDefaultPickupDateTimeChange="(val) => editDefaultPickupDateTime = val"
          @defaultPickupDayChange="handlePickupDayChange"
          @defaultPickupTimeChange="(val) => defaultPickupTime = val"
        />
        <preferences-default-day-time
          number="2"
          :edit-default-pickup-date-time="editDefaultPickupDateTime2"
          :default-pickup-day-text="defaultPickupDayText2"
          :default-pickup-time-text="defaultPickupTimeText2"
          :default-pickup-day="defaultPickupDay2"
          :default-pickup-time="defaultPickupTime2"
          :pickup-days="pickupDays"
          :pickup-hours="pickupHours2"
          @editDefaultPickupDateTimeChange="(val) => editDefaultPickupDateTime2 = val"
          @defaultPickupDayChange="handlePickupDay2Change"
          @defaultPickupTimeChange="(val) => defaultPickupTime2 = val"
        />
        <preferences-default-day-time
          number="3"
          :edit-default-pickup-date-time="editDefaultPickupDateTime3"
          :default-pickup-day-text="defaultPickupDayText3"
          :default-pickup-time-text="defaultPickupTimeText3"
          :default-pickup-day="defaultPickupDay3"
          :default-pickup-time="defaultPickupTime3"
          :pickup-days="pickupDays"
          :pickup-hours="pickupHours3"
          @editDefaultPickupDateTimeChange="(val) => editDefaultPickupDateTime3 = val"
          @defaultPickupDayChange="handlePickupDay3Change"
          @defaultPickupTimeChange="(val) => defaultPickupTime3 = val"
        />
        <preferences-default-day-time
          number="4"
          :edit-default-pickup-date-time="editDefaultPickupDateTime4"
          :default-pickup-day-text="defaultPickupDayText4"
          :default-pickup-time-text="defaultPickupTimeText4"
          :default-pickup-day="defaultPickupDay4"
          :default-pickup-time="defaultPickupTime4"
          :pickup-days="pickupDays"
          :pickup-hours="pickupHours4"
          @editDefaultPickupDateTimeChange="(val) => editDefaultPickupDateTime4 = val"
          @defaultPickupDayChange="handlePickupDay4Change"
          @defaultPickupTimeChange="(val) => defaultPickupTime4 = val"
        />
      </b-card>
      <b-card
        class="shadow-none bg-transparent border-secondary my-2"
      >
        <h5 class="font-weight-bolder mb-2">
          Delivery Preferences
        </h5>
        <b-row>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <b-form-checkbox
              v-model="deliveryCallMe"
              :value="1"
              :unchecked-value="0"
            >
              Call me
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <b-form-checkbox
              v-model="deliveryUseDoorBill"
              :value="1"
              :unchecked-value="0"
            >
              Use door bill
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <b-form-checkbox
              v-model="hangerItBehindTheDoor"
              :value="1"
              :unchecked-value="0"
            >
              Hanger it behind the door
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <div class="d-flex flex-column justify-content-between align-items-start">
              <b-form-checkbox
                v-model="deliveryContactAnotherNumber"
                :value="1"
                :unchecked-value="0"
              >
                Contact another number
              </b-form-checkbox>
              <b-form-input
                v-if="deliveryContactAnotherNumber"
                v-model="deliveryPhone"
                type="text"
                placeholder="Phone Number"
                class="w-50 mt-1"
                @keypress="numbersOnly"
              />
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card
        class="shadow-none bg-transparent border-secondary my-2"
      >
        <h5 class="font-weight-bolder mb-2">
          Service Preferences
        </h5>
        <b-row>
          <b-col
            cols="12"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            class=""
          >
            <b-form-checkbox
              v-model="perfuming"
              :value="1"
              :unchecked-value="0"
            >
              Perfuming
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            class="mt-1"
          >
            <h6>Ironing Type</h6>
            <div class="d-flex flex-column justify-content-between align-items-start">
              <b-form-radio
                v-for="type in ironingTypes"
                :key="type.id"
                v-model="ironingType"
                name="ironing-type"
                :value="type.id"
              >
                {{ type.name }}
              </b-form-radio>
            </div>
          </b-col>
          <b-col
            cols="12"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            class="mt-1"
          >
            <h6>Starch Level</h6>
            <div class="d-flex flex-column justify-content-between align-items-start">
              <b-form-radio
                v-for="level in starchLevels"
                :key="level.id"
                v-model="starchLevel"
                name="starch-level"
                :value="level.id"
              >
                {{ level.name }}
              </b-form-radio>
            </div>
          </b-col>
          <b-col
            cols="12"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            class="mt-1"
          >
            <h6>Folding And Hanging</h6>
            <div class="d-flex flex-column justify-content-between align-items-start">
              <b-form-radio
                v-for="type in foldingHangingTypes"
                :key="type.id"
                v-model="foldingHanging"
                name="folding-hanging"
                :value="type.id"
              >
                {{ type.name }}
              </b-form-radio>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <div class="text-right">
        <button
          class="btn btn-success mt-1"
          :disabled="loading"
          @click="handleChangePreferences"
        >
          {{ loading ? 'Loading...' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, ref, watch } from '@vue/composition-api'
import {
  BCard,
  BRow,
  BCol,
  BFormCheckbox,
  BFormRadio,
  BFormInput,
} from 'bootstrap-vue'
import axios from 'axios'
import vSelect from 'vue-select'
import Swal from 'sweetalert2'
import PreferencesDefaultDayTime from "@/layouts/components/customers/customerDetails/PreferencesDefaultDayTime.vue";

export default {
  components: {
    PreferencesDefaultDayTime,
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BFormRadio,
    BFormInput,
    vSelect,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const handlingCallMe = ref(0)
    const handlingContactAnotherNumber = ref(0)
    const handlingPhone = ref('')
    const handlingUseDoorBill = ref(0)
    const defaultPickupDay = ref(null)
    const defaultPickupTime = ref(null)
    const defaultPickupDayText = ref('')
    const defaultPickupTimeText = ref('')
    const pickupDays = ref([])
    const pickupHours = ref([])
    const deliveryCallMe = ref(0)
    const deliveryContactAnotherNumber = ref(0)
    const deliveryPhone = ref('')
    const deliveryUseDoorBill = ref(0)
    const perfuming = ref(0)
    const ironingType = ref(null)
    const ironingTypes = ref([])
    const starchLevel = ref(null)
    const starchLevels = ref([])
    const foldingHanging = ref(null)
    const laundryBagNextToTheDoor = ref(0)
    const hangerItBehindTheDoor = ref(0)
    const foldingHangingTypes = ref([])
    const loading = ref(false)
    const editDefaultPickupDateTime = ref(false)
    const defaultPickupDay2 = ref(null)
    const defaultPickupTime2 = ref(null)
    const defaultPickupDayText2 = ref('')
    const defaultPickupTimeText2 = ref('')
    const pickupHours2 = ref([])
    const editDefaultPickupDateTime2 = ref(false)
    const defaultPickupDay3 = ref(null)
    const defaultPickupTime3 = ref(null)
    const defaultPickupDayText3 = ref('')
    const defaultPickupTimeText3 = ref('')
    const pickupHours3 = ref([])
    const editDefaultPickupDateTime3 = ref(false)
    const defaultPickupDay4 = ref(null)
    const defaultPickupTime4 = ref(null)
    const defaultPickupDayText4 = ref('')
    const defaultPickupTimeText4 = ref('')
    const pickupHours4 = ref([])
    const editDefaultPickupDateTime4 = ref(false)

    const getUserPreferences = () => {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}/pos/user/preferences/${props.customerId}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }).then(res => {
        handlingCallMe.value = res.data.data.user_preferences.handling_call_me
        handlingContactAnotherNumber.value = res.data.data.user_preferences.handling_call_another_number
        handlingPhone.value = res.data.data.user_preferences.handling_phone
        handlingUseDoorBill.value = res.data.data.user_preferences.handling_use_door_bill
        // defaultPickupDay.value = res.data.data.user_preferences.default_pickup_day ? res.data.data.user_preferences.default_pickup_day.id : null
        // if (pickupDays.value.length > 0) {
        //   pickupHours.value = defaultPickupDay.value ? pickupDays.value.filter(day => day.id === defaultPickupDay.value)[0].hours : []
        //   defaultPickupTime.value = res.data.data.user_preferences.default_pickup_time ? res.data.data.user_preferences.default_pickup_time.id : null
        // }
        defaultPickupDayText.value = res.data.data.user_preferences.default_pickup_day ? res.data.data.user_preferences.default_pickup_day.name : ''
        defaultPickupTimeText.value = res.data.data.user_preferences.default_pickup_time ? res.data.data.user_preferences.default_pickup_time.start_at + ' - ' + res.data.data.user_preferences.default_pickup_time.end_at : ''
        defaultPickupDayText2.value = res.data.data.user_preferences.default_pickup_day_2 ? res.data.data.user_preferences.default_pickup_day_2.name : ''
        defaultPickupTimeText2.value = res.data.data.user_preferences.default_pickup_time_2 ? res.data.data.user_preferences.default_pickup_time_2.start_at + ' - ' + res.data.data.user_preferences.default_pickup_time_2.end_at : ''
        defaultPickupDayText3.value = res.data.data.user_preferences.default_pickup_day_3 ? res.data.data.user_preferences.default_pickup_day_3.name : ''
        defaultPickupTimeText3.value = res.data.data.user_preferences.default_pickup_time_3 ? res.data.data.user_preferences.default_pickup_time_3.start_at + ' - ' + res.data.data.user_preferences.default_pickup_time_3.end_at : ''
        defaultPickupDayText4.value = res.data.data.user_preferences.default_pickup_day_4 ? res.data.data.user_preferences.default_pickup_day_4.name : ''
        defaultPickupTimeText4.value = res.data.data.user_preferences.default_pickup_time_4 ? res.data.data.user_preferences.default_pickup_time_4.start_at + ' - ' + res.data.data.user_preferences.default_pickup_time_4.end_at : ''
        deliveryCallMe.value = res.data.data.user_preferences.delivery_call_me
        deliveryContactAnotherNumber.value = res.data.data.user_preferences.delivery_call_another_number
        deliveryPhone.value = res.data.data.user_preferences.delivery_phone
        deliveryUseDoorBill.value = res.data.data.user_preferences.delivery_use_door_bill
        perfuming.value = res.data.data.user_preferences.perfuming
        ironingType.value = res.data.data.user_preferences.ironing_type ? res.data.data.user_preferences.ironing_type.id : null
        starchLevel.value = res.data.data.user_preferences.starch_quantity ? res.data.data.user_preferences.starch_quantity.id : null
        foldingHanging.value = res.data.data.user_preferences.folding_and_hanging_type ? res.data.data.user_preferences.folding_and_hanging_type.id : null
        laundryBagNextToTheDoor.value = res.data.data.user_preferences.laundry_bag_door
        hangerItBehindTheDoor.value = res.data.data.user_preferences.hanger_behind_the_door
      })
    }

    const getPickupDays = () => {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}/days`, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }).then(res => {
        pickupDays.value = res.data.data.days
        getUserPreferences()
      })
    }

    const getIroningTypes = () => {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}/ironing-types`, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }).then(res => {
        ironingTypes.value = res.data.data.ironing_types
      })
    }

    const getStarchLevels = () => {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}/starch-quantities`, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }).then(res => {
        starchLevels.value = res.data.data.starch_quantities
      })
    }

    const getFoldingAndHangingTypes = () => {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}/folding-and-hanging-types`, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }).then(res => {
        foldingHangingTypes.value = res.data.data.folding_and_hanging_types
      })
    }

    const handlePickupDayChange = val => {
      defaultPickupDay.value = val
      defaultPickupTime.value = null
      pickupHours.value = defaultPickupDay.value ? pickupDays.value.filter(day => day.id === defaultPickupDay.value)[0].hours : []
    }

    const handlePickupDay2Change = val => {
      defaultPickupDay2.value = val
      defaultPickupTime2.value = null
      pickupHours2.value = defaultPickupDay2.value ? pickupDays.value.filter(day => day.id === defaultPickupDay2.value)[0].hours : []
    }

    const handlePickupDay3Change = val => {
      defaultPickupDay3.value = val
      defaultPickupTime3.value = null
      pickupHours3.value = defaultPickupDay3.value ? pickupDays.value.filter(day => day.id === defaultPickupDay3.value)[0].hours : []
    }

    const handlePickupDay4Change = val => {
      defaultPickupDay4.value = val
      defaultPickupTime4.value = null
      pickupHours4.value = defaultPickupDay4.value ? pickupDays.value.filter(day => day.id === defaultPickupDay4.value)[0].hours : []
    }

    const handleChangePreferences = () => {
      loading.value = true

      const data = {
        handling_call_me: handlingCallMe.value,
        handling_call_another_number: handlingContactAnotherNumber.value,
        handling_use_door_bill: handlingUseDoorBill.value,
        delivery_call_me: deliveryCallMe.value,
        delivery_call_another_number: deliveryContactAnotherNumber.value,
        delivery_use_door_bill: deliveryUseDoorBill.value,
        perfuming: perfuming.value,
        ironing_type_id: ironingType.value,
        starch_quantity_id: starchLevel.value,
        folding_and_hanging_type_id: foldingHanging.value,
        laundry_bag_door: laundryBagNextToTheDoor.value,
        hanger_behind_the_door: hangerItBehindTheDoor.value,
        auto_pickup: 0,
      }

      if (editDefaultPickupDateTime.value) {
        data.default_pickup_day_id = defaultPickupDay.value
        data.default_pickup_time_id = defaultPickupTime.value
        data.auto_pickup = 1
      }

      if (editDefaultPickupDateTime2.value) {
        data.default_pickup_day_id_2 = defaultPickupDay2.value
        data.default_pickup_time_id_2 = defaultPickupTime2.value
        data.auto_pickup = 1
      }

      if (editDefaultPickupDateTime3.value) {
        data.default_pickup_day_id_3 = defaultPickupDay3.value
        data.default_pickup_time_id_3 = defaultPickupTime3.value
        data.auto_pickup = 1
      }

      if (editDefaultPickupDateTime4.value) {
        data.default_pickup_day_id_4 = defaultPickupDay4.value
        data.default_pickup_time_id_4 = defaultPickupTime4.value
        data.auto_pickup = 1
      }

      if (handlingContactAnotherNumber.value) {
        if (!handlingPhone.value) {
          Swal.fire({
            title: 'You have to enter handling phone',
            icon: 'error',
            toast: true,
            timer: 3000,
            position: 'top-end',
            showConfirmButton: false,
          })
          loading.value = false
          return
        }
        data.handling_phone = handlingPhone.value
      }

      if (deliveryContactAnotherNumber.value) {
        if (!deliveryPhone.value) {
          Swal.fire({
            title: 'You have to enter delivery phone',
            icon: 'error',
            toast: true,
            timer: 3000,
            position: 'top-end',
            showConfirmButton: false,
          })
          loading.value = false
          return
        }
        data.delivery_phone = deliveryPhone.value
      }

      axios.put(`${process.env.VUE_APP_BASE_API_URL}/pos/user/preferences/${props.customerId}`, data, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }).then(res => {
        handlingCallMe.value = res.data.data.user_preferences.handling_call_me
        handlingContactAnotherNumber.value = res.data.data.user_preferences.handling_call_another_number
        handlingPhone.value = res.data.data.user_preferences.handling_phone
        handlingUseDoorBill.value = res.data.data.user_preferences.handling_use_door_bill
        defaultPickupDay.value = res.data.data.user_preferences.default_pickup_day ? res.data.data.user_preferences.default_pickup_day.id : null
        defaultPickupTime.value = res.data.data.user_preferences.default_pickup_time ? res.data.data.user_preferences.default_pickup_time.id : null
        defaultPickupDay2.value = res.data.data.user_preferences.default_pickup_day_2 ? res.data.data.user_preferences.default_pickup_day_2.id : null
        defaultPickupTime2.value = res.data.data.user_preferences.default_pickup_time_2 ? res.data.data.user_preferences.default_pickup_time_2.id : null
        defaultPickupDay3.value = res.data.data.user_preferences.default_pickup_day_3 ? res.data.data.user_preferences.default_pickup_day_3.id : null
        defaultPickupTime3.value = res.data.data.user_preferences.default_pickup_time_3 ? res.data.data.user_preferences.default_pickup_time_3.id : null
        defaultPickupDay4.value = res.data.data.user_preferences.default_pickup_day_4 ? res.data.data.user_preferences.default_pickup_day_4.id : null
        defaultPickupTime4.value = res.data.data.user_preferences.default_pickup_time_4 ? res.data.data.user_preferences.default_pickup_time_4.id : null
        deliveryCallMe.value = res.data.data.user_preferences.delivery_call_me
        deliveryContactAnotherNumber.value = res.data.data.user_preferences.delivery_call_another_number
        deliveryPhone.value = res.data.data.user_preferences.delivery_phone
        deliveryUseDoorBill.value = res.data.data.user_preferences.delivery_use_door_bill
        perfuming.value = res.data.data.user_preferences.perfuming
        ironingType.value = res.data.data.user_preferences.ironing_type ? res.data.data.user_preferences.ironing_type.id : null
        starchLevel.value = res.data.data.user_preferences.starch_quantity ? res.data.data.user_preferences.starch_quantity.id : null
        foldingHanging.value = res.data.data.user_preferences.folding_and_hanging_type ? res.data.data.user_preferences.folding_and_hanging_type.id : null
        laundryBagNextToTheDoor.value = res.data.data.user_preferences.laundry_bag_door
        hangerItBehindTheDoor.value = res.data.data.user_preferences.hanger_behind_the_door
        loading.value = false

        Swal.fire({
          title: 'Success',
          icon: 'success',
          toast: true,
          timer: 2000,
          position: 'top-end',
          showConfirmButton: false,
        })
      }).catch(err => {
        Swal.fire({
          title: 'Error',
          icon: 'error',
          toast: true,
          timer: 2000,
          position: 'top-end',
          showConfirmButton: false,
        })
        loading.value = false
      })
    }

    // eslint-disable-next-line consistent-return
    const numbersOnly = evt => {
      // eslint-disable-next-line no-param-reassign
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    }

    onMounted(() => {
      getPickupDays()
      getIroningTypes()
      getStarchLevels()
      getFoldingAndHangingTypes()
    })

    return {
      handlingCallMe,
      handlingContactAnotherNumber,
      handlingPhone,
      handlingUseDoorBill,
      pickupDays,
      pickupHours,
      defaultPickupDay,
      defaultPickupTime,
      defaultPickupDayText,
      defaultPickupTimeText,
      deliveryCallMe,
      deliveryContactAnotherNumber,
      deliveryPhone,
      deliveryUseDoorBill,
      perfuming,
      ironingType,
      ironingTypes,
      starchLevel,
      starchLevels,
      foldingHanging,
      foldingHangingTypes,
      laundryBagNextToTheDoor,
      hangerItBehindTheDoor,
      loading,
      editDefaultPickupDateTime,
      pickupHours2,
      defaultPickupDay2,
      defaultPickupTime2,
      defaultPickupDayText2,
      defaultPickupTimeText2,
      editDefaultPickupDateTime2,
      pickupHours3,
      defaultPickupDay3,
      defaultPickupTime3,
      defaultPickupDayText3,
      defaultPickupTimeText3,
      editDefaultPickupDateTime3,
      pickupHours4,
      defaultPickupDay4,
      defaultPickupTime4,
      defaultPickupDayText4,
      defaultPickupTimeText4,
      editDefaultPickupDateTime4,
      handlePickupDayChange,
      handlePickupDay2Change,
      handlePickupDay3Change,
      handlePickupDay4Change,
      handleChangePreferences,
      numbersOnly,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
